import { Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { InteractionList } from "@core/models/forms";
import { Stage } from "@core/models/pod-filter";
import { TabStatsService } from "@core/services/tab-stats.service";
import { HorizontalBarType } from "../generic-listing/generic-listing.component";
import { TabUtilsService } from "src/app/services/tab-utils.service";
import { Subscription } from "rxjs";

@Component({
  selector: "bpc-horizontal-bar",
  templateUrl: "./horizontal-bar.component.html",
  styleUrls: ["./horizontal-bar.component.scss"],
})
export class HorizontalBarComponent {
  @Input() stages: Stage[] = [];
  @Input() interactions: InteractionList[] = [];
  @Input() stageLoading: boolean = true;
  @Input() interactionLoading: boolean = true;
  @Input() loading: boolean = true;
  @Input() dataLoading!: boolean;
  @Input() type!: HorizontalBarType;

  @Output() onApplyStageEmitter: EventEmitter<Stage> = new EventEmitter<Stage>();
  @Output() onApplyInteractionEmitter: EventEmitter<InteractionList> = new EventEmitter<InteractionList>();

  @Input() useOldVersion = true;
  @Input() data: any = [];
  @Input() barClasses = "";

  total!: number;

  selectedItem = "";

  @Output() onSelection: EventEmitter<{}> = new EventEmitter<{}>();

  clearFiltersSubscription!: Subscription;

  constructor(
    public tabStatsService: TabStatsService,
    public tabUtilsService: TabUtilsService
  ) {}

  ngOnInit(){
    this.clearFiltersSubscription = this.tabUtilsService.clearFilters.subscribe(()=>{
      this.selectedItem = "";
    });

    if (this.type == HorizontalBarType.Interaction){
      this.total = 0;
      this.data.forEach((item: any) => this.total+=item.count);
      this.tabStatsService.update(this.total);
    }
  }

  ngOnChanges(changes: SimpleChanges){
    if (this.type == HorizontalBarType.Interaction){
      if (changes["data"]){
        this.total = 0;
        this.data.forEach((item: any) => this.total+=item.count);
        if (this.selectedItem === "") {
          this.tabStatsService.update(this.total);
          return;
        }
        this.data.forEach((item: any) => {
          if(item.dispalyName == this.selectedItem){
            this.tabStatsService.update(item.count);
          }
        });
      }
    }
  }

  onSelect(e: any) {
    if (this.dataLoading){
      return;
    }
    if (this.selectedItem === e.dispalyName) {
      this.selectedItem = "";
      this.onSelection.emit({ value: {} });
      if (this.type == HorizontalBarType.Interaction){
        this.tabStatsService.update(this.total);
      }
      return;
    }
    this.selectedItem = e.dispalyName;
    if (this.type == HorizontalBarType.Interaction){
      this.tabStatsService.update(e.count);
    }
    this.onSelection.emit({ value: e });
  }

  onApplyStatus(stage: Stage) {
    this.onApplyStageEmitter.emit(stage);
  }

  onApplyInteraction(interaction: InteractionList) {
    this.onApplyInteractionEmitter.emit(interaction);
  }

  ngOnDestroy(): void{
    if (this.clearFiltersSubscription)
      this.clearFiltersSubscription.unsubscribe();
  }
}
